/* eslint-disable */

import React, { useEffect } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { Form, Field } from 'react-final-form';
import './RecommendationSettings.scss';
import { updateSalesforceUserLinks } from 'Shared/actions/organizations';
import { getSalesforceUsers } from 'Shared/actions/organizations';
import TopNavigation from './components/TopNavigation/TopNavigation';
import { WpPageLayout, WpPageBody } from 'Wpds/components/page-layout';
import SalesforceUserTagArea from './components/SalesforceUserTagArea/SalesforceUserTagArea';
import uniqBy from 'lodash/uniqBy';
import flatten from 'lodash/flatten';

// Hooks
import { useApp } from 'Shared/utils/hooks/use-app';

const ImportSalesforceUsers = () => {
  const dispatch = useDispatch();
  const {app} = useApp();
  const salesforce_users = useSelector(state => state.organization.salesforce_users);

  useEffect(() => {
    dispatch(getSalesforceUsers());

    window.analytics.track('Viewed Import Salesforce Users', {
      app_id: app.id,
    });
  }, [dispatch]);

  const handleImportSubmit = links => {
    dispatch(updateSalesforceUserLinks(Object.entries(links)));
  };

  if (!salesforce_users) return <div>Loading ...</div>;

  const user_attributes = ['Name', 'Tags', 'Title', 'Email', 'Integrated Email', 'Integrated Calendar'];
  const initial_values = Object.fromEntries(
    salesforce_users.map(salesforce_user => [salesforce_user.salesforce_id, salesforce_user.imported])
  );
  const uniq_user_tags = uniqBy(flatten(salesforce_users.map(salesforce_user => salesforce_user.tags)), 'value');
  const tableCellForUserAttribute = (salesforce_user, attribute) => {
    if (attribute === 'Tags')
      return (
        <td className="" key={attribute}>
          <SalesforceUserTagArea
            userId={salesforce_user.salesforce_id}
            tags={salesforce_user.tags}
            tagOptions={uniq_user_tags}
          />
        </td>
      );
    return (
      <td className="" key={attribute}>
        {salesforce_user[attribute]}
      </td>
    );
  };

  return (
    <WpPageLayout width="full" className="SalesAssistantImportUsersPage">
      <TopNavigation />
      <WpPageBody>
        <div>
          <h3>Add Salesforce Users to Sales Assistant</h3>
          <p className="text-muted">Choose which Salesforce users get nudges.</p>
          {salesforce_users.length == 0 && (
            <div className="alert alert-warning">
              No Salesforce users found. If the Salesforce sync is still in progress then refresh the page in a few
              minutes.
            </div>
          )}
          {salesforce_users.length > 0 && (
            <Form
              initialValues={initial_values}
              onSubmit={handleImportSubmit}
              render={({ dirty, handleSubmit }) => (
                <form onSubmit={handleSubmit}>
                  <div style={{ maxHeight: '65vh', overflow: 'auto' }}>
                    <table className="table border-bottom wp-table">
                      <thead className="">
                        <tr>
                          <th className="small">Added</th>
                          {user_attributes.map(attribute => (
                            <th className="small" key={attribute}>
                              {attribute}
                            </th>
                          ))}
                        </tr>
                      </thead>

                      <tbody>
                        {salesforce_users.map(salesforce_user => (
                          <tr key={salesforce_user.salesforce_id}>
                            <td className="">
                              <Field name={salesforce_user.salesforce_id} component="input" type="checkbox" />
                            </td>
                            {user_attributes.map(attribute => tableCellForUserAttribute(salesforce_user, attribute))}
                          </tr>
                        ))}
                      </tbody>
                    </table>
                  </div>

                  <div className="row mt-2">
                    <div className="col-sm-4">
                      <button type="submit" className="btn btn-primary" disabled={!dirty}>
                        Save
                      </button>
                    </div>
                  </div>
                </form>
              )}
            />
          )}
        </div>
      </WpPageBody>
    </WpPageLayout>
  );
};

export default ImportSalesforceUsers;
